import {
  faBuildingColumns, faCity, faMusic, faTree, faTruck,
} from '@fortawesome/pro-regular-svg-icons';

const FORM_VISUALS = {
  question1: {
    accent: '#e67746',
    accentSoft: '#fff0e7',
    icon: faBuildingColumns,
  },
  question2: {
    accent: '#3d9ecf',
    accentSoft: '#e8f5fb',
    icon: faTruck,
  },
  question3: {
    accent: '#8b5cf6',
    accentSoft: '#f3edff',
    icon: faCity,
  },
  question4: {
    accent: '#d9a11d',
    accentSoft: '#fff6dc',
    icon: faMusic,
    iconOffsetX: -1,
  },
  question5: {
    accent: '#6b9f5b',
    accentSoft: '#edf7e8',
    icon: faTree,
  },
};

export default FORM_VISUALS;